"use client";
import { Dialog, DialogContent, Divider } from "@mui/material";
import React, { useState } from "react";
import { BiChevronRight, BiEnvelope, BiPhone, BiXCircle } from "react-icons/bi";

const ReachOutToUs = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className=" group overflow-y-hidden mt-5 md:mt-0 bg-white py-3 px-6 border  font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-orange-main before:translate-y-0 hover:before:translate-y-12 before:transition-all before:w-full before:h-full before:rounded-full"
      >
        <span className="relative flex items-center text-white hover:text-orange-main group-hover:text-orange-main  ">
          Reach Out to us <BiChevronRight className="text-xl" />
        </span>
      </button>

      <Dialog
        maxWidth="xs"
        fullWidth={true}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogContent className="bg-gradient-to-r from-orange-main to-orange-main/80 relative !p-4">
          <div className="border-2 border-white rounded-lg p-5 relative ">
            <BiXCircle
              fontSize={30}
              className="text-white hover:text-primary-main transition-all duration-100 hover:duration-200 cursor-pointer absolute right-[0.3rem] top-[0.3rem] z-[9999]"
              onClick={() => setOpen(false)}
            />
            <h3 className="lg:text-xl text-md text-center mb-1 text-white font-bold ">
              Reach Out to us
            </h3>
            <Divider
              sx={{
                marginY: 2,
                opacity: "0.2",
              }}
            />
            <ul className="py-8  mx-auto gap-8">
              <li>
                <a
                  href="tel:+919210903903 "
                  className="flex items-center flex-col justify-center lg:text-[1.8rem] text-lg text-white mb-12 font-semibold"
                >
                  <p className="w-[35px] text-2xl text-white/70 mb-2">
                    <BiPhone />
                  </p>
                  <p className="flex text-center flex-col flex-1">
                    +91-921-0903-903
                    <span className="text-xs mt-1">You can call us</span>
                  </p>
                </a>
              </li>

             

              <li>
                <a
                  href="mailto:response@prestogroup.com "
                  className="flex items-center flex-col justify-center lg:text-[1.8rem] text-lg text-white mb-6 font-semibold"
                >
                  <p className="w-[40px] text-2xl text-white/70 mb-2">
                    <BiEnvelope />
                  </p>
                  <p className="flex text-center flex-col flex-1">
                    response@prestogroup.com
                    <span className="text-xs mt-2">You can mail us</span>
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReachOutToUs;
